import { render, staticRenderFns } from "./NewResources.vue?vue&type=template&id=3693cab2&scoped=true"
import script from "./NewResources.vue?vue&type=script&lang=js"
export * from "./NewResources.vue?vue&type=script&lang=js"
import style0 from "./NewResources.vue?vue&type=style&index=0&id=3693cab2&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3693cab2",
  null
  
)

export default component.exports